import aviator from "../../assets/img/shapes/aviator.svg";
import butterfly from "../../assets/img/shapes/butterfly.svg";
import catEye from "../../assets/img/shapes/cateye.svg";
import geometrical from "../../assets/img/shapes/geometrical.svg";
import irregular from "../../assets/img/shapes/irregular.svg";
import oval from "../../assets/img/shapes/oval.svg";
import oversized from "../../assets/img/shapes/oversized.svg";
import rectangle from "../../assets/img/shapes/rectangle.svg";
import rimless from "../../assets/img/shapes/rimless.svg";
import round from "../../assets/img/shapes/round.svg";
import shield from "../../assets/img/shapes/shield.svg";
import skiGoggles from "../../assets/img/shapes/ski.svg";
import skiMask from "../../assets/img/shapes/skimask.svg";
import square from "../../assets/img/shapes/squere.svg";
import visor from "../../assets/img/shapes/visor.svg";
import wraparound from "../../assets/img/shapes/wraparound.svg";

const normalizeShapeName = (value: unknown) =>
  String(value || "")
    .toLowerCase()
    .replace(/&amp;/g, "&")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const shapeAssets: Record<string, string> = {
  aviator,
  aviators: aviator,
  butterfly,
  "cat eye": catEye,
  cateye: catEye,
  geometric: geometrical,
  geometrical,
  irregular,
  oval,
  oversized,
  pilot: aviator,
  "pilot aviator": aviator,
  rectangle,
  rimless,
  round,
  shield,
  "ski goggles": skiGoggles,
  "ski mask": skiMask,
  square,
  visor,
  wraparound,
};

/**
 * Return the build-managed SVG for a known frame shape.
 *
 * Importing the SVGs makes Vite fingerprint or inline them in the fingerprinted
 * application bundle. That lets the storefront use immutable caching without
 * depending on the stable `/image/shapes/*.svg` URLs returned by OpenCart.
 */
export const shapeAssetUrl = (name: unknown): string =>
  shapeAssets[normalizeShapeName(name)] || "";
